import { z } from "zod";

export const ReminderSchema = z.object({
  id: z.int().positive().readonly(),
  description: z.string().nullable(),
  alert_date: z.iso.datetime().nullable(),
  status: z.string().min(1).readonly(),
  is_seen: z.boolean().nullish(),
  alert_type: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10)
  ]),
  alert_tag: z
    .enum([
      "Status",
      "Categorized as",
      "Phase",
      "Tagged",
      "Team Assignment",
      "Note Added",
      "Note Deleted",
      "Note Updated",
      "Checklist Added",
      "Checklist Completed",
      "Checklist Nudge",
      "Checked",
      "Unchecked",
      "Reminder",
      "Reminder Added",
      "Reminder Updated",
      "Event Assigned",
      "Event Removed",
      "Event Extended",
      "Event Shortened",
      "Event Changed"
    ])
    .nullable(),
  repeat_count: z.int().min(0).max(2147483647),
  recurring_interval: z.enum(["Never", "Daily", "Weekly", "Monthly", "Yearly"])
});
